<template>
  <el-dialog
    :visible="visible"
    width="30%"
    @close="cancel"
    destroy-on-close
    :title="openType === 'add' ? '新增品牌' : '编辑品牌'"
    custom-class="customModal">
    <AppForm
      v-if="visible"
      ref="form"
      formStyle="default"
      :fields="formFields"
      :rules="rules"
      :defaultValues="defaultValues"
      @cancel="cancel"
      @submit="submita"
      />
  </el-dialog>
</template>

<script>
import { BrandService } from '../../service/brand.service';
  export default {
    name: 'formbrandList',
    data() {
      return {
        openType: 'add',
        visible: false,
        defaultValues: {},
        rules: {
          brand_name: [{ required: true, message: '权限名称不能为空'}],
          brand_desc: [{ required: true, message: '品牌描述不能为空'}],
          site_url: [{ required: true, message: '排序不能为空'}],
          images: [{ required: true, message: '请选择品牌图标'}],
        },
        formFields: [
          { type: 'input', key: 'brand_name', label: '品牌名称', span: 24 },
          { type: 'image', key: 'images', label: '品牌Logo', span: 24, pathType: 'brand', limit: 1 },
          { type: 'input', key: 'site_url', label: '品牌网址', span: 24 },
          { type: 'input', key: 'brand_desc', label: '品牌描述', span: 24 },
        ]
      }
    },
    methods: {
      open(openType, data) {
        this.openType = openType;
        if (openType === 'edit') {
          const defaultValues = JSON.parse(JSON.stringify(data));
          defaultValues.images = [{
            uid: 1,
            name: '图片异常',
            status: 'done',
            url: BrandService.spliceImg(defaultValues.brand_logo),
          }];
          this.defaultValues = defaultValues;
        } else {
          this.defaultValues = {};
        }
        this.visible = true;
      },
      cancel() {
        this.visible = false;
      },
      async submita(data) {
        await BrandService.save(data);
        this.$emit('success');
        this.cancel();
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>